import { Check, ChevronDown, Circle, LockKeyhole, Sparkles } from "lucide-react";
import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import type { CourseCatalog, CourseTier, LessonSummary } from "../types/api";

function LessonLink({ lesson }: { lesson: LessonSummary }) {
  if (lesson.locked) {
    return <div className="lesson-nav-link is-locked"><LockKeyhole size={15} /><span>{lesson.title}</span></div>;
  }
  return (
    <NavLink className="lesson-nav-link" to={`/learn/${lesson.id}`}>
      {lesson.completed ? <span className="lesson-state is-complete"><Check size={12} /></span> : <Circle size={14} />}
      <span>{lesson.title}</span>
    </NavLink>
  );
}

export function LessonSidebar({ catalog }: { catalog: CourseCatalog }) {
  const [open, setOpen] = useState<Record<CourseTier, boolean>>({ A: true, B: true });

  return (
    <div className="course-navigation">
      {(["A", "B"] as const).map((tier) => {
        const lessons = catalog.courses[tier];
        const locked = tier === "B" && catalog.user.plan !== "B";
        return (
          <section key={tier} className="course-nav-section">
            <button className="course-nav-title" onClick={() => setOpen((state) => ({ ...state, [tier]: !state[tier] }))} aria-expanded={open[tier]}>
              <span className={`tier-mini tier-${tier}`}>{tier}</span>
              <span><strong>Programmer {tier}</strong><small>{tier === "A" ? "Foundations" : "Advanced systems"}</small></span>
              {locked && <LockKeyhole size={14} />}
              <ChevronDown className={open[tier] ? "chevron-open" : ""} size={15} />
            </button>
            {open[tier] && (
              <div className="lesson-nav-list">
                {lessons.map((lesson) => <LessonLink key={lesson.id} lesson={lesson} />)}
                {locked && <Link className="sidebar-upgrade" to="/#plans"><Sparkles size={14} />Unlock Programmer B</Link>}
              </div>
            )}
          </section>
        );
      })}
    </div>
  );
}
